/**
 * @generated SignedSource<<fbdb83181f12b9a7b865f9297122ab81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompletionPeriodType = "ALL_TIME" | "BEFORE_NEXT_WEEK" | "BEFORE_NOW" | "LAST_30_DAYS" | "LAST_7_DAYS" | "LAST_WEEK" | "THIS_WEEK" | "%future added value";
export type CoachClientProgramRouteQuery$variables = {
  period: CompletionPeriodType;
  program: string;
  username: string;
  week: number;
};
export type CoachClientProgramRouteQuery$data = {
  readonly client: {
    readonly displayName: string | null | undefined;
    readonly username: string;
  } | null | undefined;
  readonly enrollment: {
    readonly program: {
      readonly description: string | null | undefined;
      readonly id: string;
      readonly imageURL: string | null | undefined;
      readonly length: number;
      readonly name: string;
      readonly slug: string;
      readonly weeks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly description: string | null | undefined;
            readonly id: string;
            readonly week: number;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"RefreshSlug">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"CoachClientProgram_enrollment">;
  } | null | undefined;
  readonly enrollments: {
    readonly " $fragmentSpreads": FragmentRefs<"CoachClientProgram_enrollments">;
  } | null | undefined;
};
export type CoachClientProgramRouteQuery = {
  response: CoachClientProgramRouteQuery$data;
  variables: CoachClientProgramRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "period"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "program"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "week"
},
v4 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "client",
  "variableName": "username"
},
v8 = [
  (v7/*: any*/)
],
v9 = [
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "program",
    "variableName": "program"
  }
],
v10 = {
  "kind": "Variable",
  "name": "period",
  "variableName": "period"
},
v11 = {
  "kind": "Variable",
  "name": "week",
  "variableName": "week"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageURL",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "length",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "week",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "after",
      "value": ""
    },
    {
      "kind": "Literal",
      "name": "first",
      "value": 9999
    },
    (v11/*: any*/)
  ],
  "concreteType": "WeeksConnection",
  "kind": "LinkedField",
  "name": "weeks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WeeksEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Week",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            (v18/*: any*/),
            (v13/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentWeek",
  "storageKey": null
},
v21 = [
  {
    "kind": "Literal",
    "name": "raw",
    "value": true
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": (v21/*: any*/),
  "kind": "ScalarField",
  "name": "date",
  "storageKey": "date(raw:true)"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachClientProgramRouteQuery",
    "selections": [
      {
        "alias": "client",
        "args": (v4/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CoachClientProgram_enrollments"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Enrollment",
        "kind": "LinkedField",
        "name": "enrollment",
        "plural": false,
        "selections": [
          {
            "args": [
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "CoachClientProgram_enrollment"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Program",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RefreshSlug"
              },
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CoachClientProgramRouteQuery",
    "selections": [
      {
        "alias": "client",
        "args": (v4/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "active",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "upcoming",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "past",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Program",
                    "kind": "LinkedField",
                    "name": "program",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v16/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Enrollment",
        "kind": "LinkedField",
        "name": "enrollment",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "alias": null,
            "args": (v21/*: any*/),
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": "startDate(raw:true)"
          },
          (v20/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "completion",
                "value": true
              },
              {
                "kind": "Literal",
                "name": "period",
                "value": "ALL_TIME"
              },
              (v11/*: any*/)
            ],
            "concreteType": "Completion",
            "kind": "LinkedField",
            "name": "completion",
            "plural": false,
            "selections": [
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v11/*: any*/)
            ],
            "concreteType": "Activity",
            "kind": "LinkedField",
            "name": "activities",
            "plural": true,
            "selections": [
              (v23/*: any*/),
              (v18/*: any*/),
              (v15/*: any*/),
              {
                "alias": "formattedDate",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "format",
                    "value": "MMM DD, YYYY"
                  }
                ],
                "kind": "ScalarField",
                "name": "date",
                "storageKey": "date(format:\"MMM DD, YYYY\")"
              },
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submitted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Component",
                "kind": "LinkedField",
                "name": "component",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "days",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "locked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Program",
                    "kind": "LinkedField",
                    "name": "program",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "iconName",
                        "storageKey": null
                      }
                    ],
                    "type": "ComponentIcon",
                    "abstractKey": "__isComponentIcon"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "habitsCheckIns",
            "args": [
              {
                "kind": "Literal",
                "name": "componentTypes",
                "value": [
                  "HABIT",
                  "CHECKIN"
                ]
              }
            ],
            "concreteType": "Activity",
            "kind": "LinkedField",
            "name": "activities",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activeStreak",
                "storageKey": null
              },
              (v23/*: any*/),
              {
                "alias": null,
                "args": [
                  (v10/*: any*/)
                ],
                "concreteType": "Completion",
                "kind": "LinkedField",
                "name": "completion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Component",
                "kind": "LinkedField",
                "name": "component",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "activities(componentTypes:[\"HABIT\",\"CHECKIN\"])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Program",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slugId",
                    "storageKey": null
                  }
                ],
                "type": "Slug",
                "abstractKey": "__isSlug"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "37dabaa1c806cf288655348e3acb7c39",
    "id": null,
    "metadata": {},
    "name": "CoachClientProgramRouteQuery",
    "operationKind": "query",
    "text": "query CoachClientProgramRouteQuery(\n  $username: String!\n  $program: String!\n  $week: Int!\n  $period: CompletionPeriodType!\n) {\n  client: user(username: $username) {\n    username\n    displayName\n    id\n  }\n  enrollments(client: $username) {\n    ...CoachClientProgram_enrollments\n  }\n  enrollment(client: $username, program: $program) {\n    ...CoachClientProgram_enrollment_FLZdE\n    program {\n      ...RefreshSlug\n      name\n      description\n      imageURL\n      id\n      slug\n      length\n      weeks(first: 9999, after: \"\", week: $week) {\n        edges {\n          node {\n            id\n            week\n            description\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ActivityByTypesList_activities_2eZHIz on Activity {\n  ...ActivityList_activities_2eZHIz\n  component {\n    type\n    id\n  }\n}\n\nfragment ActivityCard_activity_2eZHIz on Activity {\n  id\n  date(raw: true)\n  formattedDate: date(format: \"MMM DD, YYYY\")\n  completed\n  submitted\n  component {\n    ...ComponentIcon_component\n    type\n    title\n    slug\n    days\n    locked\n    program {\n      slug\n      id\n    }\n    id\n  }\n}\n\nfragment ActivityList_activities_2eZHIz on Activity {\n  ...ActivityCard_activity_2eZHIz\n  id\n  week\n  date(raw: true)\n  completed\n  component {\n    id\n    type\n  }\n}\n\nfragment CoachClientProgram_enrollment_FLZdE on Enrollment {\n  id\n  startDate(raw: true)\n  currentWeek\n  completion(week: $week, completion: true, period: ALL_TIME) {\n    rate\n  }\n  activities(week: $week) {\n    date(raw: true)\n    week\n    ...ActivityByTypesList_activities_2eZHIz\n    id\n  }\n  ...HabitCheckInProgress_enrollment_pb5Z3\n}\n\nfragment CoachClientProgram_enrollments on EnrollmentConnection {\n  edges {\n    node {\n      active\n      upcoming\n      past\n      currentWeek\n      program {\n        name\n        slug\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment ComponentIcon_component on ComponentIcon {\n  __isComponentIcon: __typename\n  iconName\n  type\n}\n\nfragment HabitCheckInProgressTable_activities_pb5Z3 on Activity {\n  id\n  activeStreak\n  date(raw: true)\n  completion(period: $period) {\n    total\n    completed\n    rate\n  }\n  component {\n    id\n    type\n    title\n    slug\n  }\n}\n\nfragment HabitCheckInProgress_enrollment_pb5Z3 on Enrollment {\n  startDate(raw: true)\n  habitsCheckIns: activities(componentTypes: [HABIT, CHECKIN]) {\n    ...HabitCheckInProgressTable_activities_pb5Z3\n    id\n  }\n}\n\nfragment RefreshSlug on Slug {\n  __isSlug: __typename\n  slug\n  slugId\n}\n"
  }
};
})();

(node as any).hash = "55dcbec78f782d347b97e528738e2c39";

export default node;
